<template>
  <div class="content if-profile">
    <PulseLoader :loading="setLoading" :class="{ hide: !setLoading }"
      quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter"
      img="picasso.jpg"></PulseLoader>
    <div class="md-layout finanical-insights-body">
      <CPHeader :headerData="ifInfo ? ifInfo : ''" />
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div v-if="ifInfo" class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <h1 class="section_header"></h1>
          <div class="md-toolbar-row md-layout fundamentals_wpr fundamental-menu p-0">
            <nav-tabs-card class="md-layout-item md-medium-size-100 md-size-100 profile-layout-tbs if_card">
              <template slot="content">
                <md-tabs md-alignment="left" class="p-0">
                  <md-tab id="tab-financial-insights" md-label="Company Details" md-icon="developer_board" class="p-0">
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-card class="if_card">
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100">
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-50">
                                    <div class="md-card multiples-text-card company_map">
                                      <div v-if="profileInfo !== null" class="md-card-content border-0"
                                        md-alignment="left">
                                      </div>
                                      <div class="extra_info">
                                        <h3>
                                          <md-icon><div class="dark-blue-color">business</div></md-icon>{{ profileInfo.companyTitle }}
                                        </h3>
                                        <div>
                                          <small>
                                            {{ profileInfo.address ? profileInfo.address : '' }}<br>
                                            <b v-if="profileInfo.businessOwner">Contact: </b>
                                            {{
                                                profileInfo.businessOwner
                                                  ? profileInfo.businessOwner
                                                  : ''
                                            }}<br profileInfo.businessOwner />
                                            <b v-if="profileInfo.phone">Phone: </b>
                                            {{ `${profileInfo.phone}`
                                            }}<br v-if="profileInfo.phone" />

                                          </small>
                                        </div>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">people_alt</div></md-icon>People
                                        </h3>
                                        <ul class="md-layout">
                                          <li class="md-layout-item md-size-50" v-for="item in contacts" :key="item.id">
                                            <img src="/img/placeholder.png" alt="Avatar user"/>
                                            <h5>
                                              {{ item.first_name }} {{ item.last_name }}
                                              <span>{{ item['labels.title_codes'] }}</span>
                                            </h5>
                                          </li>
                                        </ul>
                                         <h3>
                                          <md-icon><div class="dark-blue-color">business_center</div></md-icon>Business Operation Detail
                                        </h3>
                                        <small>
                                          <strong>Location Sales: </strong>{{ ifInfo.bizop['Location Sales'].toString()}}<br>
                                          <strong>Employment: </strong>{{ ifInfo.bizop['Employment'].toString()}}<br>
                                          <strong>Corporate Sales: </strong>{{ ifInfo.bizop['Corporate Sales'].toString()}}<br>
                                          <strong>Corporate Employment: </strong>{{ ifInfo.bizop['Corporate Employment'].toString()}}<br>
                                        </small>
                                         <h3>
                                          <md-icon><div class="dark-blue-color">point_of_sale</div></md-icon>Company Valuation - Median
                                        </h3>
                                        <small>
                                           <strong>Sales-based: </strong>{{ ifInfo.multiples.data.Median.sales }}<br>
                                           <strong>Earnings-based: </strong>{{ ifInfo.multiples.data.Median.earnings}}<br>
                                        </small>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">cases</div></md-icon>Business Details
                                        </h3>
                                        <small>
                                          <strong>Alternative Name:
                                          </strong>{{ ifInfo.expanded.companyDetails.alternativeName }}<br>
                                          <strong>Legal Name: </strong>{{ ifInfo.expanded.companyDetails.legalName
                                          }}<br>
                                          <strong>In Business Since:
                                          </strong>{{ ifInfo.expanded.companyDetails.estimatedOpenedForBusiness }}<br>
                                        </small>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">tap_and_play</div></md-icon>Connect
                                        </h3>
                                        <div class="md-layout">
                                          <div class="md-layout-item md-size-50">

                                            <small>
                                              <strong>Phone : </strong>{{ ifInfo.expanded.companyDetails.phone }}<br>
                                              <strong>Toll Free Number:
                                              </strong>{{ ifInfo.expanded.companyDetails.tollFreeNumber }}<br>
                                              <strong>Fax: </strong>{{ ifInfo.expanded.companyDetails.faxNumber }}<br>
                                              <strong>Additional Phone Number:
                                              </strong>{{ ifInfo.expanded.companyDetails.additionalPhone }}<br>
                                            </small>
                                          </div>
                                          <div class="md-layout-item md-size-50 px-4" v-if="
                                            operatingHours &&
                                            operatingHours.start_time
                                          ">
                                            <p>
                                              <b>
                                                {{
                                                    operatingHours['labels.days']
                                                }}
                                              </b>
                                              <br>
                                              <b>
                                                {{
                                                    operatingHours['start_time']
                                                }}
                                                to
                                                {{ operatingHours['end_time'] }}
                                              </b>
                                            </p>
                                          </div>
                                        </div>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">language</div></md-icon>Web
                                        </h3>
                                        <div class="md-layout">
                                          <div class="md-layout-item md-size-50">
                                            <small>
                                              <strong>Website:</strong> {{ ifInfo.expanded.webPresense.website }}
                                              <br><br>
                                              <strong>Website Keywords:</strong><br>
                                              {{ ifInfo.expanded.webPresense.websiteKeywords }} <br><br>
                                              <strong>Has Ecommerce:</strong>
                                              {{ ifInfo.expanded.webPresense.hasEcommerce }} <br>
                                            </small>
                                            <div class="social-icon" v-for="item in socials" :key="item">
                                              <a :href="item.url" target="_blank">
                                                <i :class="item.icon"></i>
                                              </a>
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="md-layout-item md-medium-size-100 md-size-50 company_map">
                                    <div class="md-card md-card-profile multiples-text-card">
                                      <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div> -->
                                      <div class="md-card-content" md-alignment="left">
                                        <google-map-loader v-if="!setLoading" ref="mapRef" :locations="location"
                                          :center="mapCenter" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </div>
                  </md-tab>

                  <md-tab id="cash-flow" md-label="Company Information" md-icon="developer_board" class="p-0 ss">
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-card class="if_card">
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100">
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-50">
                                    <div class="md-card multiples-text-card company_map">
                                      <div v-if="profileInfo !== null" class="md-card-content border-0"
                                        md-alignment="left">
                                      </div>
                                      <div class="extra_info">
                                        <h3>
                                          <md-icon class="dark-blue-color">business</md-icon>Company Classification
                                        </h3>
                                        <div>
                                          <small>
                                            <strong>Industry:</strong>{{ ifInfo.industry }}<br>
                                            <strong>Sector: </strong>{{ ifInfo.sector }}<br>
                                            <strong>SIC Code:</strong>{{
                                                ifInfo.expanded.companyClassifications.primarySIC
                                            }}<br>
                                            <strong>NAICS Code:</strong>{{
                                                ifInfo.expanded.companyClassifications.primaryNAICS
                                            }}<br>
                                            <strong>Business Types:</strong>
                                            <div v-for="item in ifInfo.expanded.companyClassifications.businessTypes"
                                              :key="item">
                                              {{ item.label }}
                                            </div><br>
                                          </small>
                                        </div>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">business</div></md-icon>Public Information
                                        </h3>
                                        <div>
                                          <small>
                                            <strong>Languages Spoken:</strong>{{
                                                ifInfo.expanded.companyDescription.languagesSpoken
                                            }}<br>
                                            <strong>Public Access: </strong>{{
                                                ifInfo.expanded.companyDescription.publicAccess
                                            }}<br>
                                            <strong>ATM Available:</strong>{{
                                                ifInfo.expanded.companyDescription.shoppingCenterATM
                                            }}<br>
                                            <strong>Greenscore:</strong>{{
                                                ifInfo.expanded.companyDescription.greenScore
                                            }}<br>
                                          </small>
                                        </div>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">business</div></md-icon>Location Details
                                        </h3>
                                        <div>
                                          <small>
                                            <strong>Mailing Address:</strong>{{
                                                ifInfo.expanded.mailingAddress.mailingAddress
                                            }}<br>
                                            <strong>Mailing Address State: </strong>{{
                                                ifInfo.expanded.mailingAddress.mailingAddressState
                                            }}<br>
                                            <strong>Mailing Address Zip:</strong>{{
                                                ifInfo.expanded.mailingAddress.mailingAddressZip
                                            }}<br>
                                            <strong>Mailing Address Zip Four:</strong>{{
                                                ifInfo.expanded.mailingAddress.mailingAddressZipFour
                                            }}<br>
                                            <strong>Delivery Point Bar Code: </strong>{{
                                                ifInfo.expanded.mailingAddress.deliveryPointBarCode
                                            }}<br>
                                            <strong>Mailing Address Delivery Point Bar Code: </strong>{{
                                                ifInfo.expanded.mailingAddress.mailingAddressDeliveryPointBarCode
                                            }}<br>
                                            <strong>Neighborhood: </strong>{{ ifInfo.expanded.location.neighborhood
                                            }}<br>
                                            <strong>Landmark Address: </strong>{{
                                                ifInfo.expanded.locationDetails.landmarkAddress
                                            }}<br>
                                            <strong>Building Number: </strong>{{
                                                ifInfo.expanded.locationDetails.buildingNumber
                                            }}<br>
                                            <strong>Number of Tenants: </strong>{{
                                                ifInfo.expanded.locationDetails.numberOfTenants
                                            }}<br>
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="md-layout-item md-medium-size-100 md-size-50 company_map">
                                    <div class="md-card md-card-profile multiples-text-card">
                                      <div class="md-card multiples-text-card company_map mt-1">
                                        <div v-if="profileInfo !== null" class="md-card-content border-0"
                                          md-alignment="left">
                                        </div>
                                        <div class="extra_info">
                                          <h3>
                                            <md-icon class="dark-blue-color">business</md-icon>Corporate Details
                                          </h3>
                                          <div>
                                            <small>
                                              <strong>Last Ownership Changed Date:</strong>{{
                                                  ifInfo.expanded.corporateDetails.ownershipChangedOn
                                              }}<br>
                                              <strong>Location Employee Count: </strong>{{
                                                  ifInfo.expanded.corporateDetails.estimatedLocationEmployeeCount
                                              }}<br>
                                              <strong>Corporate Headquarters:</strong>{{
                                                  ifInfo.expanded.corporateDetails.corporateHeadquarters
                                              }}<br>
                                              <strong>Franchise Chain:</strong>{{
                                                  ifInfo.expanded.corporateDetails.franchiseChain
                                              }}<br>
                                              <strong>Corporate Franchise: </strong>{{
                                                  ifInfo.expanded.corporateDetails.corporateFranchise
                                              }}<br>
                                              <strong>Corporate Employee Count: </strong>{{
                                                  ifInfo.expanded.corporateDetails.corporateEmployeeCount
                                              }}<br>
                                              <strong>Fortune 1000 Ranking:
                                              </strong>{{ ifInfo.expanded.corporateDetails.fortunateRanking }}<br>
                                              <strong>Fiscal Year End Month: </strong>{{
                                                  ifInfo.expanded.corporateDetails.fiscalYearEndMonth
                                              }}<br>
                                              <strong>Stock Exchange Code: </strong>{{
                                                  ifInfo.expanded.corporateDetails.stockExchangeCode
                                              }}<br>
                                              <strong>Stock Ticker Symbol: </strong>{{
                                                  ifInfo.expanded.corporateDetails.stockTickerSymbol
                                              }}<br>
                                            </small>
                                          </div>
                                          <h3>
                                            <md-icon>business</md-icon>Brands
                                          </h3>
                                          <div v-if="ifInfo.expanded.brandes">
                                            <small v-for="item in ifInfo.expanded.brandes.brandList" :key="item">
                                                {{item.label}}
                                            </small>
                                            
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </div>
                  </md-tab>
                  <md-tab id="cash-flow2" md-label="Company Commerce Details" md-icon="developer_board" class="p-0 ss">
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-card class="if_card">
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100">
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-40">
                                    <div class="md-card multiples-text-card company_map">
                                      <div v-if="profileInfo !== null" class="md-card-content border-0"
                                        md-alignment="left">
                                      </div>
                                      <div class="extra_info">
                                        <h3>
                                          <md-icon class="dark-blue-color">business</md-icon>Payment Methods
                                        </h3>
                                        <div>
                                          <small>
                                            <strong>Payment Types: </strong>{{
                                                ifInfo.expanded.paymentMethods.paymentTypes
                                            }}<br>
                                            <strong>Insurance Accepted:</strong>{{
                                                ifInfo.expanded.paymentMethods.insurancesAccepted
                                            }}<br>
                                            <strong>Medicare Accepted:</strong>{{
                                                ifInfo.expanded.paymentMethods.medicareAccepted
                                            }}<br>
                                            <strong>Medicaid Accepted:</strong>
                                            <p v-for="item in ifInfo.expanded.paymentMethods.medicaidAccepted"
                                              :key="item">
                                              {{ item }}
                                            </p>
                                          </small>
                                        </div>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">business</div></md-icon>Company Credit
                                        </h3>
                                        <div>
                                          <small>
                                            <strong>Credit Record Created Date:</strong>{{
                                                ifInfo.expanded.credit.creditRecordCreatedDate
                                            }}<br>
                                            <strong>Credit Grade: </strong>{{
                                                ifInfo.expanded.credit.creditGrade
                                            }}<br>
                                            <strong>Credit Limit:</strong>{{
                                                ifInfo.expanded.credit.creditLimit
                                            }}<br>
                                            <strong>Credit Score:</strong>{{
                                                ifInfo.expanded.credit.creditScore
                                            }}<br>
                                          </small>
                                        </div>
                                        <h3>
                                          <md-icon><div class="dark-blue-color">business</div></md-icon>Bankruptcy Profile
                                        </h3>
                                        <div v-if="ifInfo.expanded.bankruptcy">
                                          <div v-for="item in ifInfo.expanded.bankruptcy" :key="item">
                                            <small>
                                              <strong>Bankruptcy Recorded Created Date: </strong>{{
                                                  item.bankruptcyRecordCreatedData
                                              }}<br>
                                              <strong>Bankruptcy Dismissed: </strong>{{
                                                  item.dismissal == 1 ? 'Yes' : 'No'
                                              }}<br>
                                              <strong>Bankruptcy Filing Date: </strong>{{
                                                  item.filingDate
                                              }}<br>
                                              <strong>Bankruptcy Release Date: </strong>{{
                                                  item.releaseDate
                                              }}<br>
                                              <strong>Bankruptcy Filing Type: </strong>{{
                                                  item.filingType
                                              }}<br>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="md-layout-item md-medium-size-100 md-size-60 company_map">
                                    <div class="md-card md-card-profile multiples-text-card ">
                                      <div class="md-card multiples-text-card  company_map mt-1">
                                        <div v-if="profileInfo !== null" class="md-card-content border-0"
                                          md-alignment="left">
                                        </div>
                                        <div class="extra_info">
                                          <h3>
                                            <md-icon class="dark-blue-color">business</md-icon>Benefit Plans
                                          </h3>
                                          <div v-if="ifInfo.expanded.benefitsPlans">
                                            <div v-for="(item, key) in ifInfo.expanded.benefitsPlans" :key="key">
                                              <h3 v-if="key !== 0">
                                              </h3>
                                              <div>
                                                <small>
                                                  <strong>Benefits Plans Active Beginning Participants:
                                                  </strong>{{ item.active_beginning_participants }}<br>
                                                  <strong>Benefits Plans Active Ending Participants:
                                                  </strong>{{ item.active_ending_participants }}<br>
                                                  <strong>Benefits Plans Benefit Arrangements:
                                                  </strong>{{ item.benefit_arrangements }}<br>
                                                  <strong>Benefits Plans Broker City : </strong>{{ item.broker_city
                                                  }}<br>
                                                  <strong>Benefits Plans Broker Name: </strong>{{ item.broker_name
                                                  }}<br>
                                                  <strong>Benefits Plans Broker Postal Code:
                                                  </strong>{{ item.broker_postal_code }}<br>
                                                  <strong>Benefits Plans Broker State:
                                                  </strong>{{ item.broker_state }}<br>
                                                  <strong>Benefits Plans Broker Street:
                                                  </strong>{{ item.broker_street }}<br>
                                                  <strong>Benefits Plans Carrier: </strong>{{ item.carrier }}<br>
                                                  <strong>Benefits Plans Contract Number:
                                                  </strong>{{ item.contract_number }}<br>
                                                  <strong>Benefits Plans Effective Date
                                                    :</strong>{{ item.effective_date }}<br>
                                                  <strong>Benefits Plans Funding Arrangements:
                                                  </strong>{{ item.funding_arrangements }}<br>
                                                  <strong>Benefits Plans Name :</strong>{{ item.name }}<br>
                                                  <strong>Benefits Plans Short Form: </strong>{{ item.short_form }}<br>
                                                  <strong>Benefits Plans Term: </strong>{{ item['term.lower'] }} -
                                                  {{ item['term.upper'] }}<br>
                                                  <strong>Benefits Plans Total Beginning Participants:
                                                  </strong>{{ item.total_beginning_participants }}<br>
                                                  <strong>Benefits Plans Welfare Benefit Types:
                                                  </strong>{{ item.welfare_benefit_types }}<br>
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </div>
                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { PulseLoader } from '@/components';
import GoogleMapLoader from '@/pages/Dashboard/Components/GoogleMapLoader';
import { NavTabsCard } from "@/components";
import { mapState } from 'vuex';
import CPHeader from "./_partials/CPHeader.vue";
import { posthog } from '@/main';

export default {
  name: 'company-profile',
  components: {
    NavTabsCard,
    PulseLoader,
    GoogleMapLoader,
    CPHeader
  },
  data() {
    return {
      loading: true,
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      filtered_company_profile_list: [],
    };
  },
  methods: {
      numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Company Profile.csv';
      anchor.click();
    },
  },

  mounted() {
    const info = this.$store.getters.profileInfo;
    posthog.capture('company_profile_viewed', {
      company_id: this.$route.params.id,
      company_name: info?.companyTitle,
      industry: info?.naics,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    socials() {
      let socials = [];
      let details = this.ifInfo.fine_details.socials;

      if (details.facebook)
        socials.push({
          name: 'Facebook',
          url: details.facebook,
          icon: 'fab fa-facebook',
        });
      if (details.foursquare)
        socials.push({
          name: 'FourSquare',
          url: details.foursquare,
          icon: 'fab fa-foursquare',
        });
      if (details.instagram)
        socials.push({
          name: 'Instagram',
          url: details.instagram,
          icon: 'fab fa-instagram',
        });
      if (details.linked_in)
        socials.push({
          name: 'LinkedIn',
          url: details.linked_in,
          icon: 'fab fa-linkedin',
        });
      if (details.pinterest)
        socials.push({
          name: 'Pinterest',
          url: details.pinterest,
          icon: 'fab fa-pinterest',
        });
      if (details.tumblr)
        socials.push({
          name: 'Tumblr',
          url: details.tumblr,
          icon: 'fab fa-tumblr',
        });
      if (details.twitter)
        socials.push({
          name: 'Twitter',
          url: details.twitter,
          icon: 'fab fa-twitter',
        });
      if (details.yelp)
        socials.push({ name: 'Yelp', url: details.yelp, icon: 'fab fa-yelp' });
      if (details.youtube)
        socials.push({
          name: 'YouTube',
          url: details.youtube,
          icon: 'fab fa-youtube',
        });

      return socials;
    },

    companyLogo() {
      let companyLogo = '';
      if (this.ifInfo && this.ifInfo.fine_details) {
        companyLogo = this.ifInfo.fine_details.logo;
      }
      return companyLogo;
    },
    contacts() {
      let contacts = [];
      if (this.ifInfo && this.ifInfo.fine_details) {
        contacts = this.ifInfo.fine_details.contacts;
      }
      return contacts;
    },
    operatingHours() {
      return this.ifInfo.fine_details.hours
        ? this.ifInfo.fine_details.hours[0]
        : {};
    },
    industries() {
      return this.ifInfo.fine_details.industry;
    },
    profileInfo() {
      return this.$store.getters.profileInfo;
    },
    releaseDate() {
      return this.$store.getters.releaseDate;
    },
    location() {
      return [
        {
          CONAME: this.profileInfo.companyTitle,
          lat: this.profileInfo.latlon.lat,
          lng: this.profileInfo.latlon.lon,
        },
      ];
    },
    mapCenter() {
      return this.profileInfo
        ? { lat: this.profileInfo.latlon.lat, lon: this.profileInfo.latlon.lon }
        : null;
    },
    getFormattedData() {
      let a = {};

      a.company = this.profileInfo.companyTitle;
      a.original_name = '';
      a.infogroup = this.profileInfo.locnum;
      a.unique_id = '';
      a.street = this.profileInfo.street ? this.profileInfo.street : '';
      a.city = this.profileInfo.city ? this.profileInfo.city : '';
      a.state = this.profileInfo.state ? this.profileInfo.state : '';
      a.zip = this.profileInfo.zip ? this.profileInfo.zip : '';
      a.industry_code = this.profileInfo.naics;
      a.industry = this.profileInfo.industry;

      let b = this.profileInfo.businessOwner
        ? this.profileInfo.businessOwner.split(',')[0]
        : '';
      a.contact_first = b.split(' ')[0];
      a.contact_last = b.split(' ')[1];
      a.phone = this.profileInfo.businessPhone
        ? this.profileInfo.businessPhone
        : '';
      a.url = this.profileInfo.businessURL ? this.profileInfo.businessURL : '';
      let g = this.profileInfo.release_id.replace('_', '-01-20');
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

      a.operation_details =
        monthNames[new Date(g).getMonth()] + ' ' + new Date(g).getFullYear();
      a.location_annual_sales = this.profileInfo.bizop['Location Sales'][0];
      a.location_employment = this.profileInfo.bizop['Employment'][0];
      a.corporation_annual_sales = this.profileInfo.bizop['Corporate Sales'][0];
      a.corporation_employment = this.profileInfo.bizop[
        'Corporate Employment'
      ][0];

      a.market_insights_date =
        monthNames[new Date(g).getMonth()] + ' ' + new Date(g).getFullYear();
      a.market_industry_code = this.profileInfo.IMRnaics;
      a.market_industry = this.profileInfo.IMRindustry;
      a.market_area = this.profileInfo['MR']['area'];

      a.industry_operations = this.profileInfo['MR']['main'][
        'Industry Operations'
      ];
      a.location_sales_rank = this.profileInfo['MR']['main'][
        'Business Sales Rank'
      ];
      a.industry_market_sales_volume = this.profileInfo['MR']['main'][
        'Annual Market Sales Volume'
      ];
      a.average_site_sales = this.profileInfo['MR']['main'][
        'Average Site Sales'
      ];
      a.average_small_business_sales = this.profileInfo['MR']['main'][
        'Average Small Business Sales'
      ];

      a.industry_market_sales_per_person = this.profileInfo['MR'][
        'penetration'
      ]['Market Sales per Person'];
      a.us_industry_sales_per_person = this.profileInfo['MR']['penetration'][
        'US Sales per Person'
      ];
      a.opportunity_index_person = this.profileInfo['MR']['penetration'][
        'Opportunity Index Person'
      ];
      a.industry_market_sales_per_household = this.profileInfo['MR'][
        'penetration'
      ]['Market Sales per Household'];
      a.us_industry_sales_per_household = this.profileInfo['MR']['penetration'][
        'US Sales per Household'
      ];
      a.opportunity_index_household = this.profileInfo['MR']['penetration'][
        'Opportunity Index Household'
      ];

      a.market_area_population = this.profileInfo['MR']['income']['Population'];
      a.market_area_households = this.profileInfo['MR']['income']['Households'];
      a.per_capita_income = this.profileInfo['MR']['income'][
        'Per Capita Income'
      ];
      a.mediab_hh__income = this.profileInfo['MR']['income'][
        'Median HH Income'
      ];
      a.business_values_insights_date =
        monthNames[new Date(g).getMonth()] + ' ' + new Date(g).getFullYear();

      a.sales_approach_quartile1 = this.profileInfo.multiples.data[
        'Quartile 1'
      ]['sales'];
      a.sales_approach_median = this.profileInfo.multiples.data['Median'][
        'sales'
      ];
      a.sales_approach_quartile3 = this.profileInfo.multiples.data[
        'Quartile 3'
      ]['sales'];
      a.earnings_approach_quartile1 = this.profileInfo.multiples.data[
        'Quartile 1'
      ]['earnings'];
      a.earnings_approach_median = this.profileInfo.multiples.data['Median'][
        'earnings'
      ];
      a.earnings_approach_quartile3 = this.profileInfo.multiples.data[
        'Quartile 3'
      ]['earnings'];

      a.if_industry_code = this.profileInfo.naics;
      a.if_industry_name = this.profileInfo.industry;
      a.if_industry_sales_class = this.profileInfo.IF['sales-class'];
      a.financial_insights_date = this.profileInfo.IF['period'];

      a.gross_margin_percentage = this.profileInfo.IF.spend[
        'Gross Margin'
      ].percentage;
      a.office_owner_compensation_percentage = this.profileInfo.IF.spend[
        'Officer-Owner-Compensation'
      ].percentage;
      a.depreciation_percentage = this.profileInfo.IF.spend[
        'Depreciation'
      ].percentage;
      a.operating_expense_percentage = this.profileInfo.IF.spend[
        'Operating Expenses'
      ].percentage;
      a.operating_income_percentage = this.profileInfo.IF.spend[
        'Operating Income'
      ].percentage;
      a.after_tax_net_profit_percentage = this.profileInfo.IF.spend[
        'After Tax Net Profit'
      ].percentage;
      a.owner_earnings_percentage = this.profileInfo.IF.spend[
        'Owner Earnings'
      ].percentage;
      a.account_receivable_percentage = this.profileInfo.IF.spend[
        'Accounts Receivable: Total Assets'
      ].percentage;
      a.account_payable_percentage = this.profileInfo.IF.spend[
        'Accounts Payable: TLNW'
      ].percentage;
      a.net_worth_assets_percentage = this.profileInfo.IF.spend[
        'Net Worth: Assets'
      ].percentage;

      a.gross_margin_dollar = this.profileInfo.IF.spend['Gross Margin'].dollar;
      a.office_owner_compensation_dollar = this.profileInfo.IF.spend[
        'Officer-Owner-Compensation'
      ].dollar;
      a.depreciation_dollar = this.profileInfo.IF.spend['Depreciation'].dollar;
      a.operating_expense_dollar = this.profileInfo.IF.spend[
        'Operating Expenses'
      ].dollar;
      a.operating_income_dollar = this.profileInfo.IF.spend[
        'Operating Income'
      ].dollar;
      a.after_tax_net_profit_dollar = this.profileInfo.IF.spend[
        'After Tax Net Profit'
      ].dollar;
      a.owner_earnings_dollar = this.profileInfo.IF.spend[
        'Owner Earnings'
      ].dollar;
      a.account_receivable_dollar = this.profileInfo.IF.spend[
        'Accounts Receivable: Total Assets'
      ].dollar;
      a.account_payable_dollar = this.profileInfo.IF.spend[
        'Accounts Payable: TLNW'
      ].dollar;
      a.net_worth_assets_dollar = this.profileInfo.IF.spend[
        'Net Worth: Assets'
      ].dollar;

      a.account_payable_revenue = this.profileInfo.IF.benchmarks[
        'Accounts Payable: Revenue'
      ];
      a.current_ratio = this.profileInfo.IF.benchmarks['Current Ratio'];
      a.days_payable = this.profileInfo.IF.benchmarks['Days Payable'];
      a.net_working_capital_revenue = this.profileInfo.IF.benchmarks[
        'Net Working Capital Revenue'
      ];
      a.days_receivable = this.profileInfo.IF.benchmarks['Days Receivable'];
      a.interest_coverage = this.profileInfo.IF.benchmarks['Interest Coverage'];
      a.current_liabilites = this.profileInfo.IF.benchmarks[
        'Current Liabilities: NW'
      ];
      a.loans_notes = this.profileInfo.IF.benchmarks[
        'Loans‐Notes Payable: Net Worth'
      ];
      a.modified_z = this.profileInfo.IF.benchmarks['Modified Z Score'];
      a.total_liabilities = this.profileInfo.IF.benchmarks[
        'Total Liabilties: Net Worth'
      ];

      Object.values(a).forEach((element, index) => {
        let b = '';
        if (element && element.includes(',')) {
          b = element.replace(/,/g, '.');
        } else {
          b = element;
        }
        this.filtered_company_profile_list.push(b);
      });
      return this.filtered_company_profile_list;
    },
    getCsvData() {
      let csvData = [
        [
          'Company',
          'Original Name',
          'Infogroup ID',
          'Unique ID',
          'Street',
          'City',
          'State',
          'Zip',
          'Industry Code',
          'Industry',
          'Contact First',
          'Contact Last',
          'Phone',
          'URL',
          'Operation Detail Release',
          'Location Annual Sales',
          'Location Employment',
          'Corporate Annual Sales',
          'Corporate Employment',
          'Market Insights Date',
          'Market Industry Code',
          'Market Industry',
          'Market Area',
          'Industry Operations',
          'Location Sales Rank',
          'Industry Market Sales Volume',
          'Average Site Sales',
          'Average Small Business Sales',
          'Industry Market Sales per Person',
          'US Industry Sales per Person',
          'Opportunity Index',
          'Industry Market Sales per Household',
          'US Industry Sales per Household',
          'Opportunity Index',
          'Market Area Population',
          'Market Area Households',
          'Per Capital Income',
          'Median Household Income',
          'Business Value Insights Date',
          'Sales Approach Quartile1',
          'Sales Approach Median',
          'Sales Approach Quartile3',
          'Earnings Approach Quartile1',
          'Earnings Approach Median',
          'Earnings Approach Quartile3',
          'IF Industry code',
          'IF Industry name',
          'IF Sales class',
          'Financial Insights Date',
          'Gross Margin %',
          'Officer-Owner Compensation %',
          'Depreciation %',
          'Operating Expense %',
          'Operating Income %',
          'After Tax Net Profit %',
          'Owner Earnings %',
          'Accounts Receivable/Total Assets %',
          'Accounts Payable/TLNW %',
          'Net Worth/Assets %',
          'Gross Margin $',
          'Officer-Owner Compensation $',
          'Depreciation $',
          'Operating Expense $',
          'Operating Income $',
          'After Tax Net Profit $',
          'Owner Earnings $',
          'Accounts Receivable/Total Assets $',
          'Accounts Payable/TLNW $',
          'Net Worth/Assets $',
          'Accounts Payable/Revenue',
          'Current Ratio',
          'Days Payable',
          'Net Working Capital/Revenue',
          'Days Receivable',
          'Interest Coverage',
          'Current Liabilities/Net Worth',
          'Loans Notes Payable/Net Worth',
          'Modified Z Score',
          'Total Liabilties/Net Worth',
        ],
      ];

      csvData.push(this.getFormattedData);
      return csvData;
    },
    setLoading() {
      return !this.profileInfo;
    },
  },
};
</script>

<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.company-list-title {
  margin: 0 !important;
}

.mt-1 {
  margin-top: 15px !important;
  text-align-last: left !important;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.if-profile-body {
  .companis-list-tabl {
    .favorite-list-item {
      .list-item-head {
        align-items: center;
      }
    }
  }

  .compani-list {
    iframe {
      height: 280px;
    }
  }
}

.map-box-title {
  padding: 0 24px;
}

.subtitle {
  font-size: 1.1rem;
}

.company-logo {
  text-align: right;
  float: right;
  width: auto !important;
  height: 48px !important;
}

.company_map #google-map {
  height: 600px !important;
}

.type-profile .md-card-profile .md-card-header, .type-profile .marketprof-competitors .sub_table .md-table table tr th.md-table-head, .type-profile .demographics .companis-list-tabl li .md-collapse .md-collapse-label, .type-profile .if-profile .if_card .md-card-profile .md-card-header,
.sub_table .md-table table tr th.md-table-head,
.extra_info h3 .md-icon {
  color: #003666 !important;
}

</style>
